/* Lazy video posters. loading="lazy" is not valid on <video>, so sections write the poster URL to
   data-poster and this sets poster when the video comes within 300px of the viewport (or when a
   closed <details> holding it is opened). Without JavaScript the video still plays from its controls.
   Usage: <video controls preload="none" data-poster="{{ 'x.webp' | asset_url }}" width=".." height="..">
   Call window.top1LazyPosters.scan(root) after inserting new markup. */
(function () {
  'use strict';
  var SELECTOR = 'video[data-poster]:not([poster])';
  var observer = null;

  function reveal(video) {
    var url = video.getAttribute('data-poster');
    if (url && !video.getAttribute('poster')) video.setAttribute('poster', url);
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var videos = scope.querySelectorAll(SELECTOR);
    for (var i = 0; i < videos.length; i++) {
      if (observer) observer.observe(videos[i]);
      else reveal(videos[i]);
    }
  }

  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          observer.unobserve(entries[i].target);
          reveal(entries[i].target);
        }
      }
    }, { rootMargin: '300px 0px' });
  }

  window.top1LazyPosters = { scan: scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
})();
